<template>
  <div class="min-h-screen bg-gray-50">
    <Navbar :user="user" />
    
    <div class="pt-16">
      <Dashboard v-if="currentRoute === 'dashboard'" />
      <People v-else-if="currentRoute === 'people'" />
      <PersonRegistrationInvites v-else-if="currentRoute === 'person-invites'" />
      <Properties v-else-if="currentRoute === 'properties'" />
      <Bookings v-else-if="currentRoute === 'bookings'" />
      <Analysis v-else-if="currentRoute === 'analysis'" />
      <Availabilities v-else-if="currentRoute === 'availabilities'" />
      <Profile v-else-if="currentRoute === 'profile'" :user="user" @user-updated="handleUserUpdated" />
      <TenantSettings v-else-if="currentRoute === 'tenant-settings'" />
      <Users v-else-if="currentRoute === 'users'" />
      <ServiceTypes v-else-if="currentRoute === 'service-types'" />
      <Expenses v-else-if="currentRoute === 'expenses'" />
      <About v-else-if="currentRoute === 'about'" />
      <PropertyDetail 
        v-else-if="currentRoute === 'property-detail'" 
        :propertyId="router.params.id" 
        @back="backToDashboard" 
      />
    </div>
  </div>
</template>

<script>
import Navbar from './Navbar.vue'
import Dashboard from './Dashboard.vue'
import People from './People.vue'
import PersonRegistrationInvites from './PersonRegistrationInvites.vue'
import Properties from './Properties.vue'
import Bookings from './Bookings.vue'
import Analysis from './Analysis.vue'
import Availabilities from './Availabilities.vue'
import Profile from './Profile.vue'
import TenantSettings from './TenantSettings.vue'
import Users from './Users.vue'
import ServiceTypes from './ServiceTypes.vue'
import Expenses from './Expenses.vue'
import About from './About.vue'
import PropertyDetail from './PropertyDetail.vue'
import { router, navigateTo } from '../router.js'
import { applyLoggedInPageMeta, applyPropertySkeletonMeta } from '../utils/pageMeta'

export default {
  components: {
    Navbar,
    Dashboard,
    People,
    PersonRegistrationInvites,
    Properties,
    Bookings,
    Analysis,
    Availabilities,
    Profile,
    TenantSettings,
    Users,
    ServiceTypes,
    Expenses,
    About,
    PropertyDetail
  },
  emits: ['user-updated'],
  props: {
    user: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      router
    }
  },

  computed: {
    currentRoute() {
      return router.currentRoute
    }
  },

  mounted() {
    this.syncLoggedInHead()
  },

  watch: {
    currentRoute() {
      // Ao trocar de tela (rota interna do SPA), garantir que o scroll volte
      // para o topo para evitar "carregar e manter scroll" em posições antigas.
      window.scrollTo(0, 0)
      this.syncLoggedInHead()
    }
  },

  methods: {
    syncLoggedInHead() {
      if (router.currentRoute === 'property-detail') {
        applyPropertySkeletonMeta()
        return
      }
      applyLoggedInPageMeta(router.currentRoute)
    },

    backToDashboard() {
      navigateTo('dashboard')
    },
    handleUserUpdated(user) {
      this.$emit('user-updated', user)
    }
  }
}
</script>
